/**
 * Copied from index page
 * real author @dzitnik
 * @author @dzitnik
 */
import { memo, useCallback, useState } from 'react';
import { H4 } from 'foundations-components/transitional/components/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error type dependency error
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PRODUCT_VIEWS_TOUR_SETTING = 'productViewsTourSeen';

/*
 * Temporarily copied from crm_data/static/js/settings/LocalSettings
 */
const LOCAL_SETTINGS_PREFIX = 'LocalSettings:Sales:';
function makePrefixedKey(key) {
  return LOCAL_SETTINGS_PREFIX + key;
}
function getFrom(storage, key) {
  try {
    const entry = storage[makePrefixedKey(key)];
    if (entry === undefined) {
      return entry;
    }
    return JSON.parse(entry);
  } catch (error) {
    return undefined;
  }
}
function setFrom(storage, key, value) {
  try {
    storage[makePrefixedKey(key)] = JSON.stringify(value);
    return value;
  } catch (error) {
    return undefined;
  }
}

/*
 * End from crm_data/static/js/settings/LocalSettings
 */

function ProductsViewTourPopover({
  children
}) {
  const [isOpen, setIsOpen] = useState(() => {
    const hasSeenTour = getFrom(localStorage, PRODUCT_VIEWS_TOUR_SETTING);
    return !hasSeenTour;
  });
  const handleClose = useCallback(() => {
    setFrom(localStorage, PRODUCT_VIEWS_TOUR_SETTING, true);
    setIsOpen(false);
  }, []);
  return /*#__PURE__*/_jsx(Popover, {
    use: "shepherd",
    placement: "bottom",
    "data-test-id": "products-view-tour-popover",
    inlineSize: "350px",
    showCloseButton: true,
    open: isOpen,
    animateOnMount: true,
    onOpenChange: handleClose,
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "viewsManagement.tours.products.addViewTab.header"
        })
      }),
      body: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "viewsManagement.tours.products.addViewTab.body"
        }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
          url: "https://knowledge.hubspot.com/products/how-do-i-use-products"
        })]
      })
    },
    children: children
  });
}
export default /*#__PURE__*/memo(ProductsViewTourPopover);